// extracted by mini-css-extract-plugin
module.exports = {"backgroundContainer":"Testimonial-module--backgroundContainer--3C5ii","couplesSay":"Testimonial-module--couplesSay--GKIAu"};